import debounceFunc from 'lodash/debounce';
import isNil from 'lodash/isNil';
import type { Field } from '../../../../../../services/sla-fields/types.tsx';
import { EMPTY_NAME } from './constants';

export const DEBOUNCE_INTERVAL = 300;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = <F extends (...rest: ReadonlyArray<any>) => Promise<any>>(callBack: F): F =>
	// @ts-expect-error - TS2322 - Type 'DebouncedFunc<F>' is not assignable to type 'F'.
	debounceFunc(callBack, DEBOUNCE_INTERVAL);

export const validateName = (fieldValue: Field | null): string | undefined => {
	const inputValue = fieldValue?.label.trim();
	if (isNil(inputValue) || inputValue.length < 1) {
		return EMPTY_NAME;
	}
	return undefined;
};
